import {Typography} from 'antd';

import styled from 'styled-components';

import Colors from '@styles/Colors';

export const StyledExecutionName = styled(Typography.Text)`
  color: ${Colors.whitePure};
`;
